var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-list-header"},[_c('div',{staticClass:"list-item"},[_vm._t("default")],2),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }